import { ref } from 'vue';

/**
 * Composable to centralize the state of the help menu.
 */

const isOpen = ref(false);

export function useHelpMenuState() {
    function open() {
        isOpen.value = true;
    }

    function close() {
        isOpen.value = false;
    }

    function toggle() {
        isOpen.value = !isOpen.value;
    }

    return { isOpen, open, close, toggle };
}
